import { AiHubContextMenuModule } from "@aihub/ui/context-menu";
import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import i18n_en from "./i18n/en.json";
import { DeloitteAiOfferCardBuyerComponent } from "./ui/offer-card.buyer";
import { DeloitteAiOfferCardOwnerComponent } from "./ui/offer-card.owner";
import { BASE_URI } from "./utils/token";
import { DeloitteAiTransactionResolver } from "./utils/transaction.resolver";
import { TransactionService } from "./utils/transaction.service";


@NgModule({
    declarations: [
        DeloitteAiOfferCardOwnerComponent,
        DeloitteAiOfferCardBuyerComponent,
    ],
    imports: [
        AiHubContextMenuModule,
        CommonModule,
        TranslateModule.forChild()
    ],
    exports: [
        DeloitteAiOfferCardOwnerComponent,
        DeloitteAiOfferCardBuyerComponent,
    ],
    providers: [
        TransactionService,
        DeloitteAiTransactionResolver
    ],
})
export class TransactionModule {

    public static forRoot(baseuri: string): ModuleWithProviders<TransactionModule> {
        return {
            ngModule: TransactionModule,
            providers: [{
                provide: BASE_URI,
                useValue: baseuri
            }]
        };
    }

    public constructor(
        @Optional() @SkipSelf() parentModule: TransactionModule, translateService: TranslateService
    ) {
        translateService.setTranslation("en", i18n_en, true);
    }
}
